export const BUILDING_CONFIG = {
    scout: {
        cost: [2, 0, 0, 0],
        range: { build: 7 },
        vigorPenalty: true,
    },
    barracks: {
        cost: [1, 2, 0, 0],
        range: { attack: 3, defend: 4, build: 3 },
        vigorPenalty: true,
        blockOpponentBuild: true,
        stolenResourceCount: 1,
    },
    mine: {
        cost: [2, 0, 0, 0],
        permanentResourceCost: 1,
        range: { build: 2 },
        vigorPenalty: true,
    },
    bridge: {
        cost: [0, 0, 0, 1],
        range: { build: 7 },
    },
};
//# sourceMappingURL=buildings.js.map